import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProcedureStoreService } from './procedurestore.service';
import { UserVariable } from '../../util/common/user-variable';
import { AlertService } from '../../util/alert/alert.service';
import { Router } from '@angular/router';
import { LoadingService } from '../../util/loading/loading.service';

@Component({
   selector: 'delete-modal',
   template: `   
   <div class="modal-header">
      <h4 class="modal-title pull-left">{{ title | translate }}</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
         <span aria-hidden="true">&times;</span>
      </button>
   </div>
   <div class="modal-body">
      <div class="container">
         <h6 class="text-center">
            {{ bodyText | translate }}
         </h6>
      </div>
   </div>
   <div class="modal-footer">     
      <button type="button" class="btn btn-primary btn-sm" (click)="deleteProcedureStoreItemClick(procedureStoreId); bsModalRef.hide()">{{ 'OK' | translate}}</button>
      <button type="button" class="btn btn-secondary btn-sm" (click)="bsModalRef.hide()">{{ 'CANCEL' | translate}}</button>
   </div>  
   `
})
export class DeleteModalComponent {
   public title: string = 'Delete Confirm';
   public procedureStoreId: string
   private projectId: string = UserVariable.projectId
   public bodyText: string
   public click: string

   constructor(public bsModalRef: BsModalRef, private procedureStoreService: ProcedureStoreService, private alertService: AlertService, private router: Router, private loadingService: LoadingService) { }

   ngOnit(){      
   }

   deleteProcedureStoreItemClick(procedureStoreId) {
      if(this.click == "deleteItem"){
         this.loadingService.showLoading(true, null, "", null)
         this.procedureStoreService.deleteProcedureStore(procedureStoreId)
         .subscribe(data => {
            this.loadingService.hideLoading()
            this.alertService.success(data.statusDescription)
            //location.reload()
            this.procedureStoreService.tableReloadRequest("", "", "");
         },
         error => {
            this.loadingService.hideLoading()
            this.alertService.error(error.statusDescription)
         });
      }else{
         this.loadingService.showLoading(true, null, "", null)
         this.procedureStoreService.deleteProcedureZIPItem(procedureStoreId)
         .subscribe(data => {
            this.loadingService.hideLoading()
            this.alertService.success(data.statusDescription)
            //location.reload();
            this.procedureStoreService.tableReloadRequest("", "", "");
         },
         error => {
            this.loadingService.hideLoading()
            this.alertService.error(error.statusDescription)
         });
      }      
   }
}